export enum TASK_STATUS {
  NOT_STARTED = 'Not Started',
  NEED_ASSISTANCE = 'Need Assistance',
  IN_PROGRESS = 'In Progress',
  DEFERRED = 'Deferred',
  COMPLETED = 'Completed',
}
